// The `Sales` access-control grants back-office access + impersonation without
// the full admin role. Mirrors the server-side gate in the GraphQL
// `impersonateUser` resolver (api/src/graphql/resolvers/user.js).
export const SALES_ACCESS_CONTROL = 'Sales'

interface AccessControlFlag {
  name: string
  status: string
}

interface MeWithAccessControls {
  role?: string
  accessControls?: (AccessControlFlag | null)[] | null
}

export const hasSalesAccess = (me?: MeWithAccessControls | null): boolean =>
  !!me?.accessControls?.some(
    accessControl =>
      accessControl?.name === SALES_ACCESS_CONTROL &&
      accessControl?.status === 'ENABLED'
  )

// Who may reach the back-office page and impersonate: admins or Sales users.
export const canAccessBackOffice = (me?: MeWithAccessControls | null): boolean =>
  me?.role === 'admin' || hasSalesAccess(me)
